import { SEARCH_PARAM_PREVENT_AUTH_REDIRECT } from "../common/constants";
import { useLocation } from "react-router";

export const usePreventAuthRedirectParam = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(SEARCH_PARAM_PREVENT_AUTH_REDIRECT) === "true";
};
